















import { Vue, Component } from "vue-property-decorator";
import PracticeForm from "@/components/practice/PracticeForm.vue";

@Component({
  components: { PracticeForm }
})
export default class PracticeNew extends Vue {
  data() {
    return {};
  }
}
